import Api from './Api';
import { Bot } from '../../model/bot/types';

class BotsApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Bots', headers);
  }

  get = (payload: {}) => this.instance.get('', payload);

  create = (bot: Bot) => this.instance.post('', bot);

  update = (bot: Bot) => this.instance.put(`/${bot.id!}`, bot);

  delete = (botId: string) => this.instance.delete(`/${botId}`);
}

export default BotsApi;
